import { Grid } from "@mui/material";
import { fDate } from "../../../utils/formatTime";
import { decrypt } from "../../../utils/encryptDecrypt";

const OtherDetails = (_props) => {
    const { candidateData, className } = _props
    return (
        <fieldset className={`${className}--fieldset`}>
            <legend className={`${className}--legend`}>
                Other Details
            </legend>
            {/* for web preview */}
            <div className="print-web">
                <Grid container spacing={1}>
                    {/* <Grid item lg={6} md={6} sm={6} xs={6}>
                          <p className={`${className}--text`}>
                            Do you Want Relaxation in Measurement of Height and
                            Chest?
                          </p>
                        </Grid>
                        <Grid item lg={6} md={6} sm={6} xs={6}>
                          <p className="final-preview--subText custom-rht">
                            {Number(
                              candidateData?.relaxation_in_measurement
                            ) === 1
                              ? "Yes"
                              : "No"}
                          </p>
                        </Grid> */}
                    <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className={`${className}--text`}>
                            Post Preference 1
                        </p>
                    </Grid>
                    <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className={`${className}--subText`}>
                            {candidateData?.preferential_post1
                                ? candidateData?.preferential_post1
                                : "-"}
                        </p>
                    </Grid>
                    <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className={`${className}--text`}>
                            Post Preference 2
                        </p>
                    </Grid>
                    <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className={`${className}--subText`}>
                            {candidateData?.preferential_post2
                                ? candidateData?.preferential_post2
                                : "-"}
                        </p>
                    </Grid>
                    <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className={`${className}--text`}>
                            Exam Centre Preference 1
                        </p>
                    </Grid>
                    <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className={`${className}--subText`}>
                            {candidateData?.first_preference
                                ? candidateData?.first_preference
                                : "-"}
                        </p>
                    </Grid>
                    <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className={`${className}--text`}>
                            Exam Centre Preference 2
                        </p>
                    </Grid>
                    <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className={`${className}--subText`}>
                            {candidateData?.second_preference
                                ? candidateData?.second_preference
                                : "-"}
                        </p>
                    </Grid>
                    <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className={`${className}--text`}>
                            Is there any criminal case pending against you?
                        </p>
                    </Grid>
                    <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className={`${className}--subText`}>
                            {String(candidateData?.is_criminal) === "1" && "Yes"}
                            {String(candidateData?.is_criminal) === "0" && "No"}
                            {String(candidateData?.is_criminal) !== "1" &&
                                String(candidateData?.is_criminal) !== "0" &&
                                "-"}
                        </p>
                    </Grid>
                    {Number(candidateData?.is_criminal) === 1 && (
                        <>
                            <Grid item lg={6} md={6} sm={6} xs={6}>
                                <p className={`${className}--text`}>
                                    Criminal Details
                                </p>
                            </Grid>
                            <Grid item lg={6} md={6} sm={6} xs={6}>
                                <p className={`${className}--subText`}>
                                    {candidateData?.crime_details
                                        ? candidateData?.crime_details
                                        : "-"}
                                </p>
                            </Grid>
                        </>
                    )}
                    <Grid item lg={6} md={6} sm={6} xs={6} pr={6}>
                        <p className={`${className}--text`}>
                            Whether debarred or Black Listed for Examination/
                            Selection held by UKPSC / UPSC / Other State Public
                            Service Commission?
                        </p>
                    </Grid>
                    <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className={`${className}--subText`}>
                            {String(candidateData?.is_blacklist) === "1" && "Yes"}
                            {String(candidateData?.is_blacklist) === "0" && "No"}
                            {String(candidateData?.is_blacklist) !== "1" &&
                                String(candidateData?.is_blacklist) !== "0" &&
                                "-"}
                        </p>
                    </Grid>
                    {Number(candidateData?.is_blacklist) === 1 && (
                        <>
                            <Grid item lg={6} md={6} sm={6} xs={6}>
                                <p className={`${className}--text`}>
                                    BlackList From Date
                                </p>
                            </Grid>
                            <Grid item lg={6} md={6} sm={6} xs={6}>
                                <p className={`${className}--subText`}>
                                    {fDate(candidateData?.blacklist_from_date, 'dd/MM/yyyy')}
                                </p>
                            </Grid>
                            <Grid item lg={6} md={6} sm={6} xs={6}>
                                <p className={`${className}--text`}>
                                    BlackList To Date
                                </p>
                            </Grid>
                            <Grid item lg={6} md={6} sm={6} xs={6}>
                                <p className={`${className}--subText`}>
                                    {fDate(candidateData?.blacklist_to_date, 'dd/MM/yyyy')}
                                </p>
                            </Grid>
                            <Grid item lg={6} md={6} sm={6} xs={6}>
                                <p className={`${className}--text`}>
                                    BlackList Details
                                </p>
                            </Grid>
                            <Grid item lg={6} md={6} sm={6} xs={6}>
                                <p className={`${className}--subText`}>
                                    {candidateData?.blacklist_details
                                        ? candidateData?.blacklist_details
                                        : "-"}
                                </p>
                            </Grid>
                        </>
                    )}
                    <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className={`${className}--text`}>
                            Candidate ID Proof
                        </p>
                    </Grid>
                    <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className={`${className}--subText`}>
                            {candidateData?.id_proof
                                ? candidateData?.id_proof
                                : "-"}
                        </p>
                    </Grid>
                    <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className={`${className}--text`}>ID Proof Number</p>
                    </Grid>
                    <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className={`${className}--subText`}>
                            {candidateData?.id_proof_no
                                ? decrypt(candidateData?.id_proof_no)
                                : "-"}
                        </p>
                    </Grid>
                </Grid>
            </div>
            {/* for print preview */}
            <div className="print-view">
                {/* <div className="print-details d-flex">
                        <div className="w-70">
                          <p className={`${className}--text`}>
                            Do you Want Relaxation in Measurement of Height and
                            Chest?
                          </p>
                        </div>
                        <div className="w-30">
                          <p className={`${className}--subText`}>
                            {Number(candidateData?.relaxation_in_measurement)
                              ? "Yes"
                              : "No"}{" "}
                          </p>
                        </div>
                      </div> */}
                {/* <div className="print-details d-flex">
                        <div className="w-70">
                          <p className={`${className}--text`}>
                            Are You Employed?
                          </p>
                        </div>
                        <div className="w-30">
                          <p className={`${className}--subText`}>
                            {Number(candidateData?.is_employed) ? "Yes" : "No"}
                          </p>
                        </div>
                      </div>
                      {Number(candidateData?.is_employed) === 1 && (
                        <>
                          <div className="print-details d-flex">
                            <div className="w-70">
                              <p className={`${className}--text`}>
                                Type of Organisation
                              </p>
                            </div>
                            <div className="w-30">
                              <p className={`${className}--subText`}>
                                {candidateData?.employee_organization_type}
                              </p>
                            </div>
                          </div>
                          <div className="print-details d-flex">
                            <div className="w-70">
                              <p className={`${className}--text`}>
                                Date of Applying NOC
                              </p>
                            </div>
                            <div className="w-30">
                              <p className={`${className}--subText`}>
                                {fDate(
                                  candidateData?.employee_organization_noc,
                                  "dd/MM/yyyy"
                                )}
                              </p>
                            </div>
                          </div>
                        </>
                      )} */}
                <div className="print-details d-flex">
                    <div className="w-70">
                        <p className={`${className}--text`}>
                            Post Preference 1
                        </p>
                    </div>
                    <div className="w-30">
                        <p className={`${className}--subText`}>
                            {candidateData?.preferential_post1
                                ? candidateData?.preferential_post1
                                : "-"}
                        </p>
                    </div>
                </div>
                <div className="print-details d-flex">
                    <div className="w-70">
                        <p className={`${className}--text`}>
                            Post Preference 2
                        </p>
                    </div>
                    <div className="w-30">
                        <p className={`${className}--subText`}>
                            {candidateData?.preferential_post2
                                ? candidateData?.preferential_post2
                                : "-"}
                        </p>
                    </div>
                </div>
                <div className="print-details d-flex">
                    <div className="w-70">
                        <p className={`${className}--text`}>
                            Exam Centre Preference 1
                        </p>
                    </div>
                    <div className="w-30">
                        <p className={`${className}--subText`}>
                            {candidateData?.first_preference
                                ? candidateData?.first_preference
                                : "-"}
                        </p>
                    </div>
                </div>
                <div className="print-details d-flex">
                    <div className="w-70">
                        <p className={`${className}--text`}>
                            Exam Centre Preference 2
                        </p>
                    </div>
                    <div className="w-30">
                        <p className={`${className}--subText`}>
                            {candidateData?.second_preference
                                ? candidateData?.second_preference
                                : "-"}
                        </p>
                    </div>
                </div>
                <div className="print-details d-flex">
                    <div className="w-70">
                        <p className={`${className}--text`}>
                            Is there any criminal case pending against you?
                        </p>
                    </div>
                    <div className="w-30">
                        <p className={`${className}--subText`}>
                            {String(candidateData?.is_criminal) === "1" && "Yes"}
                            {String(candidateData?.is_criminal) === "0" && "No"}
                            {String(candidateData?.is_criminal) !== "1" &&
                                String(candidateData?.is_criminal) !== "0" &&
                                "-"}
                        </p>
                    </div>
                </div>
                {Number(candidateData?.is_criminal) === 1 && (
                    <div className="print-details d-flex">
                        <div className="w-70">
                            <p className={`${className}--text`}>
                                Criminal Details
                            </p>
                        </div>
                        <div className="w-30">
                            <p className={`${className}--subText`}>
                                {candidateData?.crime_details
                                    ? candidateData?.crime_details
                                    : "-"}
                            </p>
                        </div>
                    </div>
                )}
                <div className="print-details d-flex">
                    <div className="w-70">
                        <p className={`${className}--text`}>
                            Whether debarred or Black Listed for Examination/
                            Selection held by UKPSC / UPSC / Other State Public
                            Service Commission?
                        </p>
                    </div>
                    <div className="w-30">
                        <p className={`${className}--subText`}>
                            {String(candidateData?.is_blacklist) === "1" && "Yes"}
                            {String(candidateData?.is_blacklist) === "0" && "No"}
                            {String(candidateData?.is_blacklist) !== "1" &&
                                String(candidateData?.is_blacklist) !== "0" &&
                                "-"}
                        </p>
                    </div>
                </div>
                {Number(candidateData?.is_blacklist) === 1 && (
                    <>
                        <div className="print-details d-flex">
                            <div className="w-70">
                                <p className={`${className}--text`}>
                                    BlackList From Date
                                </p>
                            </div>
                            <div className="w-30">
                                <p className={`${className}--subText`}>
                                    {fDate(candidateData?.blacklist_from_date, 'dd/MM/yyyy')}
                                </p>
                            </div>
                        </div>
                        <div className="print-details d-flex">
                            <div className="w-70">
                                <p className={`${className}--text`}>
                                    BlackList To Date
                                </p>
                            </div>
                            <div className="w-30">
                                <p className={`${className}--subText`}>
                                    {fDate(candidateData?.blacklist_to_date, 'dd/MM/yyyy')}
                                </p>
                            </div>
                        </div>
                        <div className="print-details d-flex">
                            <div className="w-70">
                                <p className={`${className}--text`}>
                                    BlackList Details
                                </p>
                            </div>
                            <div className="w-30">
                                <p className={`${className}--subText`}>
                                    {candidateData?.blacklist_details
                                        ? candidateData?.blacklist_details
                                        : "-"}
                                </p>
                            </div>
                        </div>
                    </>
                )}
                <div className="print-details d-flex">
                    <div className="w-70">
                        <p className={`${className}--text`}>
                            Candidate ID Proof
                        </p>
                    </div>
                    <div className="w-30">
                        <p className={`${className}--subText`}>
                            {candidateData?.id_proof
                                ? candidateData?.id_proof
                                : "-"}
                        </p>
                    </div>
                </div>
                <div className="print-details d-flex">
                    <div className="w-70">
                        <p className={`${className}--text`}>ID Proof Number</p>
                    </div>
                    <div className="w-30">
                        <p className={`${className}--subText`}>
                            {candidateData?.id_proof_no
                                ? decrypt(candidateData?.id_proof_no)
                                : "-"}
                        </p>
                    </div>
                </div>
            </div>
        </fieldset>
    )
}

export default OtherDetails;